import { ReactNode } from "react";

export type Ingredient = {
    title: ReactNode;
    name: string;
    nameSuffix?: string;
    imageUrl: string;
    mobileImageUrl: string;
    functionText: string;
};

export type Result = {
    name: string;
    age: number;
    quote: string;
    alt: string;
    beforeImageUrl: string;
    afterImageUrl: string;
};

export const INGREDIENTS: Ingredient[] = [
    {
        title: <>Firm, hydrate & <br />reduce wrinkles</>,
        name: "Bioidentical Estriol (0.3%)",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790068786/new_design/Ingredient_Card_yh8mjh.webp",
        mobileImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790068849/new_design/Ingredient_Card_mkresc.webp",
        functionText: "The topical estrogen most studied for facial use. Your clinician calibrates the concentration to your skin — not a standard dose.",
    },
    {
        title: <>Smooth wrinkles, <br className="lg:hidden" />treat <br className="max-lg:hidden" />dark spots <br className="lg:hidden" />& acne</>,
        name: "Tretinoin (0.01%)",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790068786/new_design/Ingredient_Card_2_rw1qzk.webp",
        mobileImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790068849/new_design/Treatment_card_new_mnyovb.webp",
        functionText: "Prescription-grade retinoid. Rebuilds collagen, accelerates cell turnover, and fades hyperpigmentation at the same time.",
    },
    {
        title: <>Brighten & <br className="lg:hidden" />strengthen skin</>,
        name: "Niacinamide",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790068786/new_design/Ingredient_Card_1_uy0rnr.webp",
        mobileImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790068849/new_design/Treatment_card_new_1_ntgezd.webp",
        functionText: "Strengthens the skin barrier, targets dark spots, and buffers any initial sensitivity.",
    },
    {
        title: <>Reduce unwanted <br />facial hair, acne & oil</>,
        name: "Finasteride (0.25%)",
        nameSuffix: "Optional",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790068786/new_design/Ingredient_Card_3_gmo3cj.webp",
        mobileImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790068849/new_design/Treatment_card_new_2_wwb8ju.webp",
        functionText: "Addresses hormonal facial hair — the symptom perimenopause causes that most prescription creams don’t acknowledge.",
    },
];

export const RESULTS: Result[] = [
    {
        name: "Anon",
        age: 49,
        quote: "My skin looked plumper and a noticeable reduction in neck lines.",
        alt: "Verified patient — BodyMatched before and after, plumper skin, fewer neck lines",
        beforeImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784033413/reviews/before-4_f7rt9j.webp",
        afterImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784033413/reviews/after-4_colhfh.webp",
    },
    {
        name: "Michelle",
        age: 32,
        quote: "Since making the switch, I've seen a real drop in facial hair growth, nothing else worked for me.",
        alt: "Michelle, age 32 — BodyMatched before and after, reduced facial hair",
        beforeImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1786357259/design_system/michelle-before_kwff2e.webp",
        afterImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1786357259/design_system/michelle-after_cojxxw.webp",
    },
    {
        name: "Kim",
        age: 49,
        quote: "My neck lines softened, dark spots faded, and my complexion feels truly renewed.",
        alt: "Kim, age 49 — BodyMatched before and after, brighter plumper skin",
        beforeImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784033414/reviews/before-2_ureya1.webp",
        afterImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784033414/reviews/after-2_u49uoh.webp",
    },
];
